module.exports = __webpack_public_path__ + "static/media/video.78a37c92.mp4";